import { fromJS, Map } from 'immutable';

import {
  allAccountsLoaded,
  getAccountDepartments,
  getAccountDetails,
  getBillableAccountDepartments,
  getCurrentUser,
  passwordRecover,
  passwordReset,
  setAlwaysShowCart,
  setDeepLinkInfoLoading,
  setUserAccount,
  storeUserData
} from './actions';
import { selectDepartments, getUserData, getUserAccount } from './selectors';

export const defaultState = Map({
  accountDetails: null,
  allAccountsLoaded: false,
  alwaysShowCart: false,
  billableDepartments: [],
  departments: [],
  deepLinkInfoLoading: false,
  orderDeadlines: null,
  userData: null,
  validationError: ''
});

export default function user(state = defaultState, action) {
  const newState = fromJS(state); // Force immutable in case of rehydration
  switch (action.type) {
    // User service returns account and department numbers as an integer
    // TODO: Discuss contracts with BE team
    case getCurrentUser.event.success:
    case storeUserData.type: {
      return newState.set('userData', action.payload);
    }
    case setUserAccount.type: {
      const { id, name, number } = action.payload;
      return newState.set('userAccount', { id, name, number: `${number}` });
    }
    case allAccountsLoaded.type:
      return newState.set('allAccountsLoaded', true);
    case setDeepLinkInfoLoading.type:
      return newState.set('deepLinkInfoLoading', action.payload);
    case getAccountDepartments.event.success:
      return newState.get('departments').filter(dept => dept.customerNumber === action.payload.customerNumber)
        .length === 0
        ? newState.updateIn(['departments'], list => list.concat(action.payload))
        : newState;
    case getBillableAccountDepartments.event.success:
      return newState.get('billableDepartments').filter(dept => dept.customerNumber === action.payload.customerNumber)
        .length === 0
        ? newState.updateIn(['billableDepartments'], list => list.concat(action.payload))
        : newState;
    case getAccountDetails.event.success:
      return newState.set('accountDetails', action.payload);
    case passwordReset.event.error:
    case passwordRecover.event.error:
      return newState.set('validationError', action.payload);
    case setAlwaysShowCart.type:
      return newState.set('alwaysShowCart', action.payload);
    default:
      return newState;
  }
}

export const getCurrentDepartments = (state, accountNumber) => {
  const account = selectDepartments(state).find(dept => dept.customerNumber === accountNumber);

  return account ? account.customerDepartments : [];
};
export const getCurrentUserDeptNumbers = (state, accountNumber) => {
  const userData = getUserData(state);
  const userAccountDeptsData = userData.accountDepartments.find(account => account.accountId === accountNumber);

  return userAccountDeptsData ? userAccountDeptsData.departments : [];
};
export const userDepartments = state => {
  const userAccount = getUserAccount(state);
  const accountNumber = userAccount?.number;
  if (!accountNumber) return null;
  const deptDetails = getCurrentDepartments(state, accountNumber);
  const userDeptNumbers = getCurrentUserDeptNumbers(state, accountNumber);
  const userDeptDetails = deptDetails.filter(dept =>
    userDeptNumbers.some(deptNumber => deptNumber === dept.customerDepartmentCode)
  );
  const userDeptNames = userDeptDetails.map(dept => dept.customerDepartmentName);

  return {
    depts: userDeptDetails,
    deptNumbers: userDeptNumbers,
    deptNames: userDeptNames
  };
};
